var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 233,
    viewBox: "0 0 218 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 16",
    cx: 106.21,
    cy: 106.21,
    r: 106.21,
    fill: "#71A6C7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 15",
    filter: "url(#filter0_i_18_83)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 106.801,
    cy: 106.801,
    r: 97.3343,
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 106.577,
    cy: 106.577,
    r: 89.347,
    stroke: "black",
    strokeOpacity: 0.22,
    strokeWidth: 8,
    strokeDasharray: "6 6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 18",
    d: "M95.0585 131.896C84.0161 144.16 73.6363 148.886 70.6672 150.143C71.6256 147.378 75.2217 136.242 86.2642 123.978C97.3066 111.714 107.853 103.208 110.655 105.731C113.458 108.254 106.101 119.632 95.0585 131.896Z",
    fill: "#4B6D8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 17",
    d: "M84.7563 73.4316C75.527 49.8473 76.0365 32.4144 76.3104 27.494C79.4076 30.7249 92.0573 43.3785 101.287 66.9629C110.516 90.5472 114.999 110.839 109.732 112.901C104.465 114.962 93.9855 97.016 84.7563 73.4316Z",
    fill: "#6597C6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 13",
    filter: "url(#filter1_i_18_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.78 96.287L118.338 126.674C118.338 126.674 134.154 238.593 171.78 232.781C209.407 226.969 217.565 126.674 217.565 126.674L171.78 96.287Z",
    fill: "#84BC95"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    d: "M150.311 164.276L169.054 192.574L196.249 122.748",
    stroke: "#004202",
    strokeWidth: 22
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_18_83",
    x: 9.46704,
    y: 9.46716,
    width: 194.669,
    height: 198.669,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18_83"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_18_83",
    x: 118.338,
    y: 96.287,
    width: 99.2271,
    height: 140.713,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18_83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon 3.d0605470806703bbe38126598522604f.svg";
export { ForwardRef as ReactComponent };